/* tslint:disable:no-access-missing-member */

import {
  Component,
  Input,
  forwardRef,
  OnChanges, SimpleChanges
} from '@angular/core';

import {
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import { InputBaseComponent } from '../base/base.component';
import { InputSelectOptionModel } from './option.model';

@Component({
  selector: 'jb-input-select',
  templateUrl: './select.component.html',
  /* tslint:disable */
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSelectComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputSelectComponent),
      multi: true
    }
  ]
  /* tslint:enable */
})
export class InputSelectComponent extends InputBaseComponent implements OnChanges {
  @Input() public empty: string;

  @Input('options') public options: { [key: string]: string } | string[];

  @Input() public onOptionAdd: (value: any, key?: string) => InputSelectOptionModel;

  public parsedOptions: InputSelectOptionModel[];

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.options &&
      JSON.stringify(changes.options.currentValue) !== JSON.stringify(changes.options.previousValue)
    ) {
      this.parsedOptions = [];

      if (this.empty) {
        this.parsedOptions.push(new InputSelectOptionModel('', this.empty));
      }

      const options = changes.options.currentValue;

      if (options) {
        if (Array.isArray(options)) {
          for (const option of options) {
            if (this.onOptionAdd) {
              const optionModel = this.onOptionAdd(option);

              if (optionModel) {
                this.parsedOptions.push(optionModel);
              }
            } else {
              this.parsedOptions.push(new InputSelectOptionModel(option, option));
            }
          }
        } else {
          for (const key in options) {
            if (options.hasOwnProperty(key)) {
              if (this.onOptionAdd) {
                const optionModel = this.onOptionAdd(options[key], key);

                if (optionModel) {
                  this.parsedOptions.push(optionModel);
                }
              } else {
                this.parsedOptions.push(new InputSelectOptionModel(key, options[key]));
              }
            }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/form/input/select/select.component.ts